export const clientPath = "/client";
export const backofficePath = "/backoffice";

export const clientRegister = `${clientPath}/register`;
export const confimationRegistrationPath = `${clientRegister}/confirm-registration`;

export const addressPath = `${clientPath}/address`;
export const clientProfilePath = `${clientPath}/profile`;
export const clientCompanyPath = `${clientPath}/company`;
export const clientCompanyJoinConfirmPath = `/join-company/confirm-join`;
export const clientCompanyJoinCompleteProfilePath = `/join-company/complete-profile`;
export const clientCompanyCollaborateursPath = `${clientCompanyPath}/collaborateurs`;
export const clientMessagesPath = `${clientPath}/messages`;
export const ridesPath = `${clientPath}/rides`;
export const ridesViewPath = `${ridesPath}/view`;

export const contactsPath = `${backofficePath}/contacts`;
export const collaborateursPath = `${backofficePath}/collaborateurs`;
export const driversPath = `${backofficePath}/drivers`;
export const vehiclesPath = `${backofficePath}/vehicles`;
export const coursesPath = `${backofficePath}/courses`;
export const facturesPath = `${backofficePath}/factures`;
export const backofficeMessagesPath = `${backofficePath}/messages`;
export const companiesPath = `${backofficePath}/companies`;
export const companiesClientsPath = `${companiesPath}/clients`;
export const companiesPartnerPath = `${companiesPath}/partners`;

// La gestion des chauffeurs (creation, edition, retrait) vit dans la fiche de
// l'entreprise partenaire : cote back-office sous l'entreprise consultee, cote
// gestionnaire sous sa propre entreprise. `driversPath` n'est qu'une liste
// transversale en lecture, qui renvoie vers ces fiches.
export const partnerCompanyPath = (idEntreprise: number | string) =>
  `${companiesPartnerPath}/${idEntreprise}`;
export const partnerCompanyDriverPath = (
  idEntreprise: number | string,
  idDriver: number | string,
) => `${partnerCompanyPath(idEntreprise)}/drivers/${idDriver}`;

export const backofficeProfilePath = `${backofficePath}/profile`;

export const backofficeCompanyPath = `${backofficePath}/company`;
export const backofficeCompanyDriverPath = (idDriver: number | string) =>
  `${backofficeCompanyPath}/drivers/${idDriver}`;

export const reserverCoursePath = "/reserver-une-course";
